/** Get the outer width of an element, including margins.
 * @param {HTMLElement} el - The element to measure.
 * @param {boolean} withComputedStyle - If true, also return the computed style object.
 * @return {number|object} - The outer width in pixels, or an object with width and style.
 **/
export function outerWidth(el, withComputedStyle) {
  let width = el.offsetWidth;
  const style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return withComputedStyle ? { width: width, style: style } : width;
}
